// @ts-ignore
import { Err, Ok } from 'ts-results';
import Layer from 'ol/layer/Layer';
// @ts-ignore
Layer.prototype.GetDataTable = function (extent) {
    const features = this.getSource().getFeaturesInExtent(extent).slice(0, 100);
    if (features.length > 0) {
        const propertiesArray = [];
        features.forEach((feature) => {
            propertiesArray.push(feature.getProperties());
        });
        const table = {
            fields: features[0].getKeys(),
            data: propertiesArray,
        };
        return Ok(table);
    }
    return Err('No attribute data available for this layer.');
};
